var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashiconsEditorExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80005 11.2H18.2V16.8H9.80005V11.2ZM2.80005 18.2V23.8H8.40005L6.72005 22.12L9.80005 16.8L4.48005 19.88L2.80005 18.2ZM19.6 23.8H25.2V18.2L23.52 19.88L18.2 16.8L21.28 22.12L19.6 23.8ZM19.6 4.19995L21.42 6.01995L18.2 11.2L23.52 8.11995L25.2 9.79995V4.19995H19.6ZM8.40005 4.19995H2.80005V9.79995L4.48005 8.11995L9.80005 11.2L6.58005 6.01995",
    fill: "#8BAEC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashiconsEditorExpand);
export default __webpack_public_path__ + "static/media/dashicons-editor-expand.173f90e91d86f772d8d43257be7898f1.svg";
export { ForwardRef as ReactComponent };